import Loading from '../../../components/Loading';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import usePostApi from '../../../lib/usePostApi.js';
import * as Toast from '../../../lib/Toast.js';
import CallbackLoading from '../../../components/CallbackLoading';

const StripeReturnPage = ({}) => {
    const { businessId } = useParams();
    const navigate = useNavigate();

    const { save, isSaving } = usePostApi(
        `/api/business/${businessId}/integrations/payments/stripe/return`,
    );

    useEffect(() => {
        save().then(() => {
            Toast.success('Successfully connected Stripe');
            navigate(`/business/${businessId}/integrations`);
        });
    }, []);

    return <CallbackLoading />;
};

export default StripeReturnPage;
